/*
 * @Author: Latte
 * @Date: 2021-08-19 17:43:15
 * @LAstEditors: Latte
 * @LastEditTime: 2021-08-27 09:16:05
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\liveManagement\liveManagement.js
 */
import request from '@/utils/request'
import config from '@/utils/config'
import {handleUrlEncode} from "@/utils/urlutil";

/**
 * 直播管理接口
 */

/**
 * @description: 获取直播列表
 * @param {*} params
 * @return {*}
 */
export function getLiveList(params) {
    var url = config.API_LIVE + '/live_server/manage/live/list/all?'
    url = handleUrlEncode(url, params)
    return request({
        url: url,
        method: 'get',
    })
}

/**
 * @description: 发送直播通知
 * @param {*} data
 * @return {*}
 */
export function sendNotification(data) {
    return request({
        url: config.API_LIVE + '/live_server/manage/live/sendNotification',
        method: 'post',
        data
    })
}

/**
 * @description: 更新直播接口
 * @param {*} data
 * @return {*}
 */
export function update(data) {
    return request({
        url: config.API_LIVE + '/live_server/manage/live/update',
        method: 'post',
        data
    })
}

/**
 * @description: 后台更新直播对应的直播配置
 * @param {*} data
 * @return {*}
 */
export function updateLiveConfig(data) {
    return request({
        url: config.API_LIVE + '/live_server/manage/live/config',
        method: 'post',
        data
    })
}

/**
 * @description: 删除直播
 * @param {*} params
 * @return {*}
 */
export function deleteLive(params) {
    return request({
        url: config.API_LIVE + '/live_server/manage/live/deleteOrNot',
        method: 'delete',
        params
    })
}

/**
 * @description: 恢复被删除的直播
 * @param {*} params
 * @return {*}
 */
export function resumeLive(params) {
    return request({
        url: config.API_LIVE + '/live_server/manage/live/deleteOrNot',
        method: 'delete',
        params
    })
}

/**
 * @description: 获取观众省份统计数据
 * @param {*} params
 * @return {*}
 */
export function getProvinceData(params) {
    return request({
        url: config.API_LIVE + '/live_server/manage/live/provinceUserData',
        method: 'get',
        params
    })
}

/**
 * @description: 获取指定直播间的成员列表
 * @param {*} params
 * @return {*}
 */
export function getAllAudienceList(params) {
    let url = config.API_LIVE + '/live_server/manage/live/list/liveUser?'
    url = handleUrlEncode(url, params)
    return request({
        url: url,
        method: 'get',
    })
}

/**
 * @description: 获取指定直播间H5用户
 * @param {*} params
 * @return {*}
 */
export function getH5AudienceList(params) {
    return request({
        url: config.API_LIVE + '/live_server/manage/live/list/liveUser/h5',
        method: 'get',
        params
    })
}

/**
 * @description: 获取指定直播间预约用户
 * @param {*} params
 * @return {*}
 */
export function getReserveUserList(params) {
    return request({
        url: config.API_LIVE + '/live_server/manage/live/list/liveAppointUser',
        method: 'get',
        params
    })
}

/**
 * @description: 获取指定直播间聊天记录
 * @param {*} params
 * @return {*}
 */
export function getChatRecords(params) {
    return request({
        url: config.API_LIVE + '/live_server/manage/live/list/liveChatRecords',
        method: 'get',
        params
    })
}

/**
 * @description: 设置直播间观众虚拟人数
 * @param {*} data
 * @return {*}
 */
export function setVirtualAudienceNum(params) {
    return request({
        url: config.API_LIVE + '/live_server/manage/live/virtual',
        method: 'post',
        params
    })
}

/**
 * @description: 后台管理分页获取直播相关的录制回放列表
 * @param {*} data
 * @return {*}
 */
export function getLiveRecordVideoList(params) {
    return request({
        url: config.API_LIVE + '/live_server/manage/live/record/video/list',
        method: 'get',
        params
    })
}

/**
 * @description: 后台删除或者恢复直播录制视频
 * @param {*} data
 * @return {*}
 */
export function liveRecordVideoDeleteOrBack(params) {
    return request({
        url: config.API_LIVE + '/live_server/manage/live/record/video/deleteOrBack',
        method: 'delete',
        params
    })
}

/**
 * @description: 后台直播录制视频发布
 * @param {*} data
 * @return {*}
 */
export function liveRecordVideoPublic(data) {
    return request({
        url: config.API_LIVE + '/live_server/manage/live/record/video/public',
        method: 'post',
        data
    })
}

/**
 * @description: 后台撤销直播录制视频发布
 * @param {*} data
 * @return {*}
 */
export function liveRecordVideoUndo(params) {
    return request({
        url: config.API_LIVE + '/live_server/manage/live/record/video/public/undo',
        method: 'delete',
        params
    })
}

/**
 * @description: 后台管理分页获取直播相关的登记信息列表
 * @param {*} data
 * @return {*}
 */
export function getLiveRegistrationList(params) {
    let url = config.API_LIVE + '/live_server/manage/live/registration/list?';
    url = handleUrlEncode(url, params)
    return request({
        url: url,
        method: 'get',
    })
}

/**
 * @description: 发送直播通知
 * @param {*} data
 * @return {*}
 */
export function sendMsg2Registration(params) {
    return request({
        url: config.API_LIVE + '/live_server/manage/live/email/send',
        method: 'POST',
        data: params
    })
}

/**
 * @description: 后台管理分页获取直播间发出的签到消息记录列表
 * @param {*} data
 * @return {*}
 */
export function getLiveSignMsgList(params) {
    return request({
        url: config.API_LIVE + '/live_server/manage/live/liveSignMsg/list',
        method: 'get',
        params
    })
}

/**
 * @description: 后台删除或者恢复直播签到消息
 * @param {*} data
 * @return {*}
 */
export function deleteLiveSignMsgOrBack(params) {
    return request({
        url: config.API_LIVE + '/live_server/manage/live/liveSignMsg/deleteOrBack',
        method: 'delete',
        params
    })
}

/**
 * @description: 后台管理分页获取直播间签到记录列表
 * @param {*} data
 * @return {*}
 */
export function getLiveSignUserList(params) {
    return request({
        url: config.API_LIVE + '/live_server/manage/live/liveSign/list',
        method: 'get',
        params
    })
}

/**
 * @description: 后台删除或者恢复直播签到用户记录
 * @param {*} data
 * @return {*}
 */
export function deleteLiveSignUserOrBack(params) {
    return request({
        url: config.API_LIVE + '/live_server/manage/live/liveSignUser/deleteOrBack',
        method: 'delete',
        params
    })
}

/**
 * @description: 后台管理分页获取直播间签到用户记录列表
 * @param {*} data
 * @return {*}
 */
export function getLiveSignListByUser(params) {
    return request({
        url: config.API_LIVE + '/live_server/manage/live/liveSignUser/list',
        method: 'get',
        params
    })
}

/**
 * @description: 后台分页获取用户学分卡信息集合
 * @param {*} data
 * @return {*}
 */
export function getUserCreditCardList(params) {
    return request({
        url: config.API_ADMIN + '/Api/V1/AdminUsers/UserCreditCardList',
        method: 'get',
        params
    })
}


